export enum BANK_INPUTS {
  ABA = 'aba',
  ACCOUNT_NUMBER = 'accountNumber',
  CLABE = 'clabe',
  BANK_NAME = 'bankName',
  BANK_ADDRESS = 'bankAddress',
  BRANCH_NAME = 'branchName',
  BRANCH_CODE = 'branchCode',
  BANK_CODE = 'bankCode',
  BRANCH_AGENCY_CODE = 'branchAgencyCode',
  IBAN = 'iban',
  ROUTING_NUMBER = 'routingNumber',
  SWIFT = 'swift',
  TAX = 'taxId',
  BANK_CITY = 'bankCity',
  PHONE_NUMBER = 'phoneNumber',
  CHINESE_ID = 'chineseId',
  PROVINCE = 'province',
  IFSC_CODE = 'ifscCode',
  NATIONALITY = 'nationality',
  BIC_CODE = 'bicCode',
  SORT_CODE = 'sortCode',
  PAYMENT_CODE = 'paymentCode',
  NUBAN = 'nuban',
  BANK_MFO = 'bankMfo',
  BSBCode = 'bsbCode',
}

enum BENERICIARY_INPUTS {
  BENERICIARY_ADDRESS = 'beneficiaryAddress',
  BENERICIARY_NAME = 'beneficiaryName',
  COUNTRY_OF_RESIDENCE = 'countryOfResidence',
  DATE_OF_BIRTH = 'dateOfBirth',
  BOARDING_PASS = 'boardingPassOrBookingReference',
  PIR_REFERENCE = 'pirReference',
  PASSPORT_ID = 'passportOrId',
}

export type BankFields = { [P in BANK_INPUTS | BENERICIARY_INPUTS]?: string };
